import { Card } from '@pmi/dsm-react';
import { PeopleCardListItemProperty } from '../../PeopleCardList';
import { InternalAdminActions, InternalAdminModel } from '../models';
import styles from './internalAdminCardListTemplate.module.scss';
import RegisteredCell from '../InternalAdminList/TableCells/RegisteredCell';
import RoleCell from '../../AdminsTab/AdminsList/TableCells/RoleCell';
import ActionsCell from '../InternalAdminList/TableCells/ActionsCell';
import LastLoggedIn from '../InternalAdminList/TableCells/LastLoggedIn';

interface InternalAdminCardListTemplateProps<T, A>
  extends PeopleCardListItemProperty<T, A> {
  isDeveloper: boolean;
}
export default function InternalAdminCardListTemplate({
  item,
  actions,
  isDeveloper = false,
}: InternalAdminCardListTemplateProps<
  InternalAdminModel,
  InternalAdminActions
>) {
  const { name, email } = item;
  return (
    <Card className="listItemCard mb-3">
      <div className="p-0">
        <div className="p-4 pb-3">
          <div className="d-block mb-3">
            <strong className={styles.name}>{name}</strong>
            <span className={styles.email}>{email}</span>
          </div>
          <div className="d-block">
            <div className={`d-flex align-items-center ${styles.commonText}`}>
              <span className="me-2">Role: </span>
              <RoleCell row={{ original: item }} />
            </div>
            <div className={`d-flex align-items-center ${styles.commonText}`}>
              <span className="me-2">Registration: </span>
              <RegisteredCell row={{ original: item }} />
            </div>
            <div className={`d-flex align-items-center ${styles.commonText}`}>
              <span className="me-2">Last Accessed: </span>
              <LastLoggedIn row={{ original: item }} />
            </div>
          </div>
        </div>
        <div className={styles.actionBtns}>
          <ActionsCell
            row={{ original: item }}
            actions={actions}
            isDeveloper={isDeveloper}
          />
        </div>
      </div>
    </Card>
  );
}
